import Vue from 'vue'
import Router from 'vue-router'
import permission from './permission-route.js'
import eduHome from './edu-route.js'
import schoolHome from './school-route.js'

Vue.use(Router)

const routes = permission.concat([
	eduHome,
	schoolHome
])

const router = new Router({
	mode: 'hash',
	routes: routes
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
	if (to.path.indexOf('/schoolHome') > -1) {
		Vue.prototype.$request.get(Vue.prototype.$url.type.base,Vue.prototype.$url.school.userStatus,{},success=>{
			Vue.prototype.$global.status = success.data
			if(success.data == 0){//未预约
				nextView2(to,'/schoolHome','/schoolHome/homepage',next)
			}else if(success.data == 1){//已预约
				nextView2(to,'/schoolHome','/schoolHome/projectRecord',next)
			}else if(success.data == 2){//现场确认已预约
				nextView2(to,'/schoolHome','/schoolHome/confirmRecord',next)
			}
		},failure=>{
			nextView2(to,'/schoolHome','/schoolHome/login',next)
		})
		return
	}
	if(Vue.prototype.$global.userInfo.utype == undefined){
		Vue.prototype.$request.postNDNF(Vue.prototype.$url.type.user, '/profile', response => {
			Vue.prototype.$global.userInfo = response.result
			getPermission(to, from, next)
		})
	}else{
		getPermission(to, from, next)
	}
	
})

function getPermission(to, from, next){
	switch (Vue.prototype.$global.userInfo.utype) {
		case 2://部门主管	
		case 16://机构
		case 20://家长+机构
		case 24://老师+机构
			if(Vue.prototype.$global.userInfo.group_id == 2511 || Vue.prototype.$global.userInfo.group_id == 2509){ //人事处 教育发展中心
				nextView2(to,'/eduHome','/eduHome/projectList',next)
			}else{
				nextNoPermission(to,next)
			}
			break;
		default:
			nextNoPermission(to,next)
			break;

	}
}

function nextView(to, path, next) {
	nextView2(to, path,path, next)
}

function nextView2(to, path,default_path, next) {
	if (to.path.indexOf(path) > -1) {
		next()
	} else{
		next(default_path)
	} 
}

function nextNoPermission(to,next){
	if (to.path.indexOf('/nopermission') > -1) {
		next()
	}else{
		next('/nopermission')
	}
}
export default router